// import axios from 'axios';

// const API_URL = 'http://localhost:1337/api/post';

// export const fetchPosts = async () => {
//     try {
//         const response = await axios.get(API_URL);
//         console.log("Fetched Data:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching data:', error);
//         return { data: [] };
//     }
// };


// import axios from "axios";

// const API_URL = "http://localhost:1337/api";

// export const fetchHeader = async () => {
//     try {
//         const response = await axios.get(`${API_URL}/headers?populate=*`);
//         console.log("Fetched Header Data:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("Error fetching header:", error);
//         return null;
//     }
// };


import axios from "axios";

const API_URL = "https://api.bouwbedrijfgeluk.nl/api";
//const API_URL = "http://localhost:1337/api";

/**
 * Fetches data dynamically from any Strapi API endpoint.
 * @param {string} endpoint - The API endpoint (e.g., "posts", "headers").
 * @param {boolean} populate - Whether to populate relationships (default: false).
 * @returns {Promise<Object>} - The fetched data.
 */
export const fetchData = async (endpoint, populate = false) => {
    try {
        const url = `${API_URL}/${endpoint}${populate ? "?populate=*" : ""}`;
        const response = await axios.get(url);
        console.log(`Fetched ${endpoint} Data:`, response.data);
        return response.data?.data || {};
    } catch (error) {
        console.error(`Error fetching ${endpoint}:`, error);
        return {};
    }
};
